import PropTypes from 'prop-types';
import Image from '../../utils/Image';
import { Row, Col } from '../../utils/grid/Grid';
import HostTeaserSmall from '../hostTeaser/HostTeaserSmall';

import './theme-teaser.css';

const ThemeTeaser = (props) => (
  <div>
    <Row>
      <Col xs={12}>
        <h3 className="theme-teaser-title">{props.title}</h3>
        <Image src={props.teaser} className="theme-teaser-image" />
      </Col>
    </Row>
    <Row center="sm">
      {props.hosts.map((host, index) => (
        <Col xs={12} sm={6} lg={4} key={index}>
          <HostTeaserSmall {...host} renderPriceAlternatives />
        </Col>
      ))}
    </Row>
  </div>
);

ThemeTeaser.propTypes = {
  teaser: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  hosts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ThemeTeaser;
